import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class CardReveal {
    constructor(element) {
        this.element = element;
        this.cards = element.querySelectorAll("[data-card]");
        if (!this.cards.length) return;
        this.init();
    }

    init() {
        gsap.from(this.cards, {
            opacity: 0,
            y: 100,
            duration: 1,
            stagger: 0.3,
            ease: "power3.out",
            scrollTrigger: {
                trigger: this.element,
                start: "top 60%",
                once: true,
            }
        });
    }
}